module.exports = __webpack_public_path__ + "img/204.9252aac3.png";